module.exports = __webpack_public_path__ + "static/nav-banner-credit@2x-555bf02bfa948bffff7e6a1d062a6ee6.png";